import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';

class AddAtrributePage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.addAttribute = this.addAttribute.bind(this);


        this.state = {
            required: false,
            type: 'number'
        };
    }


    componentDidMount() {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }

        //console.log(this.props[0].match.params);
        this.setState({
            category: this.props[0].match.params.cid
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('addAttribute', (data) => {
            console.log(data);
            if (data.error) {

            } else if (data.successful) {
                this.props[0].history.push(`/categories/${this.props[0].match.params.cid}/attributes`);
                
            }
        });

    }

    addAttribute() {
        this.props.socketIOClient.emit("addAttribute", this.state);
    }
/*

    addAttributes() {
        let attrs = ['Isofix',
            'Licht und Sicht',
            'Xenonscheinwerfer',
            'Tagfahrlicht',
            'Nebelscheinwerfer',
            'Kurvenlicht',
            'Diebstahlschutz',
            'Elektrische Wegfahrsperre',
            'Elektrische Fensterheber',
            'Elektrische Seitenspiegel',
            'lektrische Sitzeinstellung',
            'Klimatisierung',
            'Keine Klimaanlage oder -automatik',
            'Klimaanlage',
            'Klimaautomatik',
            'Sitzheizung',
            'Standheizung',
            'Servolenkung',
            'Zentralverriegelung',
            'Lichtsensor',
            'Regensensor',
            'Tempomat',
            'Head-Up Display',
            'Vorne',
            'Hinten',
            'Kamera',
            'Tuner/Radio',
            'CD-Spieler',
            'MP3-Schnittstelle',
            'Bluetooth',
            'Navigationssystem',
            'Bordcomputer',
            'Multifunktionslenkrad',
            'Freisprecheinrichtung',
            'Leichtmetallfelgen',
            'Sportpaket',
            'Sportfahrwerk',
            'Sportsitze',
            'Anhängerkupplung',
            'Behindertengerecht',
            'Schiebedach',
            'Panorama-Dach',
            'Dachreling',
            'Skisack',
            'Taxi'];

            for(let i=0;i<attrs.length;i++){
                let attrObj = {
                    category: this.state.category,
                    name: attrs[i],
                    alias: this.props.generateAlias(attrs[i]),
                    type: 'check'
                };
                this.props.socketIOClient.emit("addAttribute", attrObj);

            }
    }

*/
    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("addAttribute");
    }


    render() {

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel panel-6">
                    <div className="panel-title">
                        <h1>{this.props.translate('Add new attribute')}</h1>
                        <h6>{this.props.translate('Fill fields to add attribute')}</h6>

                    </div>

                    <div>



                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Name')}</label>
                            <input type="text" value={this.state.name} onChange={(e) => { this.setState({ name: e.target.value, alias: this.props.generateAlias(e.target.value) }) }} />
                        </div>


                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Alias')}</label>
                            <input type="text" value={this.state.alias} onChange={(e) => { this.setState({ alias: e.target.value }) }} />
                        </div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Type')}</label>
                            <select value={this.state.type} onChange={(e) => { this.setState({ type: e.target.value }) }}>
                                <option value='number'>Number</option>
                                <option value='string'>String</option>
                                <option value='year'>Year</option>
                                <option value='select'>Select</option>
                                <option value='check'>Check</option>
                            </select>
                        </div>

                        <div className="input-wrap input-wrap-3">

                            <label>{this.props.translate('Required')}</label>
                            <Switch className="react-switch"
                                checked={this.state.required}
                                handleColor="white"
                                offColor="rgb(204, 204, 204)"
                                onChange={() => { this.setState({ required: !this.state.required }) }}
                                onColor="rgb(146, 44, 136)"
                                pendingOffColor={undefined}
                                pendingOnColor={undefined}
                                readOnly={undefined}
                                style={undefined}
                            />

                        </div>

                        <div className="input-wrap input-wrap-3">

                            <label>{this.props.translate('Hidden')}</label>
                            <Switch className="react-switch"
                                checked={this.state.hidden}
                                handleColor="white"
                                offColor="rgb(204, 204, 204)"
                                onChange={() => { this.setState({ hidden: !this.state.hidden }) }}
                                onColor="rgb(146, 44, 136)"
                                pendingOffColor={undefined}
                                pendingOnColor={undefined}
                                readOnly={undefined}
                                style={undefined}
                            />

                        </div>

                        {
                            this.state.type === 'select' &&
                            <div className="input-wrap ">
                                <label>{this.props.translate('Values')}</label>
                                <textarea value={this.state.values} onChange={(e) => { this.setState({ values: e.target.value }) }}>

                                </textarea>
                            </div>
                        }

                        <div className="input-wrap">
                            <button className="button" onClick={this.addAttribute}>{this.props.translate('Add')}</button>
                        </div>




                    </div>
                </div>



            </div>
        );
    }
}

export default PageWithLayout(AddAtrributePage);


// WEBPACK FOOTER //
// ./src/views/addAttributePage.js